import { w as win } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
function defineNamespace$1(implementation) {
  return { ...implementation, [Symbol.onexus.namespace]: true };
}
function defineFunction$1(handler) {
  return handler;
}
function defineEvent$1(...listeners) {
  return { [Symbol.onexus.event]: { listeners } };
}
function defineStore$1(detail, start) {
  return { [Symbol.onexus.event]: { detail, start } };
}
const defineEvent = defineEvent$1;
const defineStore = defineStore$1;
const defineFunction = defineFunction$1;
const defineNamespace = defineNamespace$1;
const otto = win.otto ?? {};
export {
  defineEvent,
  defineFunction,
  defineNamespace,
  defineStore,
  otto
};
/*                                     */
